import { Component, OnInit } from '@angular/core';
import {FieldConfig} from "@biletix/core/models/base/field-config.model";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'btx-photo-input',
  templateUrl: './btx-photo-input.component.html',
  styleUrls: ['./btx-photo-input.component.scss'],
  standalone: false
})
export class BtxPhotoInputComponent implements OnInit {

  field: FieldConfig | any;

  group: FormGroup | any;

  constructor() { }

  ngOnInit(): void {
  }

}
